import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteAreaComum(tenantId: string | null) {
  return useMutation(
    `/v1/tenants/${tenantId}/area-comum`,
    (id: string) => http.delete(`/v1/tenants/${tenantId}/area-comum/${id}`),
    { retry: false }
  );
}

export default useDeleteAreaComum;
